import { Controller } from "stimulus";

const TOOLTIP_OPTIONS = { sanitize: false, container: "body", boundary: "viewport" };

export default class extends Controller {
  static targets = ["icons", "menu", "credit"];
  static values = { hideEmptyAddons: Boolean, renderCredit: Boolean };

  toggle(event) {
    this.submit(event, "PUT");
  }

  reserveCredit(event) {
    this.submit(event, "POST");
  }

  submit(event, method) {
    event.preventDefault();
    event.stopPropagation();
    if (this.pending) return;

    const button = event.currentTarget;
    this.pending = true;
    this.setBusy(button);

    const body = new URLSearchParams({
      hide_empty_addons: this.hideEmptyAddonsValue,
      render_credit: this.renderCreditValue
    });

    fetch(button.dataset.url, {
      method: method,
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": this.csrfToken()
      },
      body: body,
      credentials: "same-origin"
    })
      .then((response) => response.json().then((json) => ({ ok: response.ok, json: json })))
      .then(({ ok, json }) => {
        if (ok) {
          this.replace(json);
        } else {
          this.clearBusy();
        }
        this.notify(json, ok);
      })
      .catch(() => {
        this.clearBusy();
        window.notyf.error("Something went wrong. Please try again.");
      })
      .finally(() => {
        this.pending = false;
      });
  }

  replace(json) {
    [["icons", this.iconsTargets], ["menu", this.menuTargets], ["credit", this.creditTargets]].forEach(([key, targets]) => {
      if (typeof json[key] !== "string") return;

      targets.forEach((target) => {
        $(target).find('[data-toggle="tooltip"]').addBack('[data-toggle="tooltip"]').tooltip("dispose");
        target.insertAdjacentHTML("beforebegin", json[key]);
        const fresh = target.previousElementSibling;
        target.remove();
        $(fresh).find('[data-toggle="tooltip"]').addBack('[data-toggle="tooltip"]').tooltip(TOOLTIP_OPTIONS);
      });
    });
  }

  notify(json, ok) {
    const messages = json.messages || [{ type: ok ? "success" : "error", message: json.message }];

    messages.forEach(({ type, message }) => {
      if (!message) return;
      if (type === "success") {
        window.notyf.success(message);
      } else {
        window.notyf.error(message);
      }
    });
  }

  setBusy(button) {
    this.busyButtons().forEach((node) => { node.disabled = true; });

    const icon = button.querySelector(".js-addon-icon");
    if (icon) {
      this.busyIcon = { node: icon, html: icon.innerHTML };
      const margin = icon.querySelector(".mr-2") ? " mr-2" : "";
      icon.innerHTML = `<i class="fad fa-spinner-third fa-spin${margin}"></i>`;
    }
  }

  clearBusy() {
    this.busyButtons().forEach((node) => { node.disabled = false; });

    if (this.busyIcon) {
      this.busyIcon.node.innerHTML = this.busyIcon.html;
      this.busyIcon = null;
    }
  }

  busyButtons() {
    return this.element.querySelectorAll('[data-action^="attendance-addons#"]');
  }

  csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.content : "";
  }
}
